/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';

export function SlackLogo(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="white" />
			<path
				d="M10.7748 18.3522C10.7748 19.391 9.92619 20.2396 8.88739 20.2396C7.8486 20.2396 7 19.391 7 18.3522C7 17.3134 7.8486 16.4648 8.88739 16.4648H10.7748V18.3522Z"
				fill="#E01E5A"
			/>
			<path
				d="M11.7249 18.3527C11.7249 17.3139 12.5734 16.4653 13.6122 16.4653C14.651 16.4653 15.4996 17.3139 15.4996 18.3527V23.0785C15.4996 24.1173 14.651 24.9659 13.6122 24.9659C12.5734 24.9659 11.7249 24.1173 11.7249 23.0785V18.3527Z"
				fill="#E01E5A"
			/>
			<path
				d="M13.6122 10.7748C12.5734 10.7748 11.7249 9.92618 11.7249 8.88739C11.7249 7.84859 12.5734 7 13.6122 7C14.651 7 15.4996 7.84859 15.4996 8.88739V10.7748H13.6122Z"
				fill="#36C5F0"
			/>
			<path
				d="M13.6132 11.7256C14.652 11.7256 15.5006 12.5742 15.5006 13.613C15.5006 14.6518 14.652 15.5004 13.6132 15.5004H8.88739C7.8486 15.5004 7 14.6518 7 13.613C7 12.5742 7.8486 11.7256 8.88739 11.7256H13.6132Z"
				fill="#36C5F0"
			/>
			<path
				d="M21.1915 13.613C21.1915 12.5742 22.0401 11.7256 23.0789 11.7256C24.1177 11.7256 24.9663 12.5742 24.9663 13.613C24.9663 14.6518 24.1177 15.5004 23.0789 15.5004H21.1915V13.613Z"
				fill="#2EB67D"
			/>
			<path
				d="M20.2389 13.6132C20.2389 14.652 19.3903 15.5006 18.3515 15.5006C17.3127 15.5006 16.4641 14.652 16.4641 13.6132V8.88739C16.4641 7.84859 17.3127 7 18.3515 7C19.3903 7 20.2389 7.84859 20.2389 8.88739V13.6132Z"
				fill="#2EB67D"
			/>
			<path
				d="M18.3527 21.1914C19.3915 21.1914 20.2401 22.04 20.2401 23.0788C20.2401 24.1176 19.3915 24.9662 18.3527 24.9662C17.3139 24.9662 16.4653 24.1176 16.4653 23.0788V21.1914H18.3527Z"
				fill="#ECB22E"
			/>
			<path
				d="M18.3524 20.2396C17.3136 20.2396 16.465 19.391 16.465 18.3522C16.465 17.3134 17.3136 16.4648 18.3524 16.4648H23.0782C24.117 16.4648 24.9656 17.3134 24.9656 18.3522C24.9656 19.391 24.117 20.2396 23.0782 20.2396H18.3524Z"
				fill="#ECB22E"
			/>
			<rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#DFE1E6" />
		</svg>
	);
}
